module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_cacahuate_triturado.f1a1de7b.jpg";